import {Component, OnInit} from '@angular/core';
import {ApiService} from '@core/service/api.service';
import {WelfareProjectResultArchive} from '@core/class/welfare-project-result-archive';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.css']
})
export class ArchiveComponent implements OnInit {

  archives: WelfareProjectResultArchive[];

  constructor(private api: ApiService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const projectID = params.id;
      if (projectID) {
        this.api.loadProjectArchive(projectID).subscribe(value => {
          this.archives = value;
        });
      }
    });
  }
}
